import request from '../../utils/request'
import { reqGetMenuListByRoleId, reqRoleAuthMenu } from './role'

const pre="/system/sysMenu";

/**
 * 获取菜单列表
 */
export const reqGetRoutes = (params) => {
  return request({
    url: pre+'/getRoutes',
    method: 'get',
    params
  })
}

export const reqListMenu = (data) => {
  return request({
    url: pre+'/page',
    method: 'POST',
    data: data
  })
}
export const reqInsertMenu = (data) => {
    return request({
        url: pre+'/insert',
        method: 'POST',
        data: data
    })
}
export const reqUpdateMenu = (data) => {
    return request({
        url: pre+'/update',
        method: 'POST',
        data: data
    })
}
//树菜单
export const reqListMenuTree=()=>{
    return request({
        url: pre+'/tree',
        method: 'get'
    })
}

/**
 * 批量删除菜单信息
 */
export const deleteMenu = (id) => {
  return request({
    url: pre+'/delete?id='+id,
    method: 'get'
  })
}

// ===== 兼容旧调用名（供 index12.vue 引用）=====
// 这两个实现实际在 role.js（/system/sysRole 前缀），此处转发导出
export const listMenuTreeByRoleId = reqGetMenuListByRoleId
export const saveMenuRole = reqRoleAuthMenu

